var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"}},[_c('circle',{attrs:{"cx":"8","cy":"8","r":"8","fill":"white"}})])}
var staticRenderFns = []

export { render, staticRenderFns }